module.exports = __webpack_public_path__ + "static/media/Story-PS-StudentMap-svg.bd7449a7.svg";